// @ts-nocheck

// Кнопка, возвращающая на верх страницы
const topButton = document.querySelector("[data-top-button]");

// Возвращение на верх страницы при нажатии на кнопку
topButton.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
});

// Показывать кнопку, если страница прокручена ниже определенного значения
window.addEventListener("scroll", () => {
    const scrollTopMin = topButton.dataset.scrollTopMin;
    if (window.scrollY > scrollTopMin) {
        topButton.classList.remove("display-none");
    } else {
        topButton.classList.add("display-none");
    }
});
